import { formatDate } from "@angular/common";
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { 
  AgeGroupService, ArrayService, AuthService, ChurchService, 
  DatabaseService, DocumentService, FestivalUserService 
} from 'src/core/services';
import { FestivalUser, DocumentReference } from '../../core/models';
import { ModalController, NavController, AlertController, LoadingController } from '@ionic/angular';
import { AddUserComponent } from '../add-user/add-user.component';
import { EditUserComponent } from '../edit-user/edit-user.component';
import { PageClass } from 'src/core/classes/page';
import { Timestamp } from 'rxjs/internal/operators/timestamp';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.less', '../../core/styles/common.less']
})

export class UserListComponent extends PageClass implements OnInit {

  churchList: DocumentReference[];
  festivalUserList: FestivalUser[] = [];

  isLoading = true;

  filter: any = { filterChurch: undefined };

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private documentService: DocumentService,
    private router: Router,
    protected festivalUserService: FestivalUserService,
    protected navController: NavController,
    protected modalController: ModalController,
    protected alertController: AlertController,
    protected loadingController: LoadingController
  ) {
      super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    this.filter = {};

    this.filter.filterChurch = localStorage.getItem('filteredChurch') ? 
      this.churchList.find(c => c.reference.id == localStorage.getItem('filteredChurch')) : 
      this.churchList[0];

    if (this.currentUser.isActive && !this.currentUser.isDeleted && this.currentUser.isAdmin) {
      this.getFestivalUserList();
    } else {
      this.router.navigate([`/`]);
    }    
  }

  public getFestivalUserList() {
    // Save Filters
    localStorage.setItem('filteredChurch', this.filter.filterChurch.reference.id);

    this.festivalUserService.getFestivalUserList(true, false, this.filter.filterChurch)
      .subscribe(festivalUserList => {
        this.festivalUserList = festivalUserList.sort(this.festivalUserService.orderByUserName);
        this.isLoading = false;
      });
  }

  addUser = async (churchList: DocumentReference[], ageGroupList: DocumentReference[]) => {
    const modal = await this.modalController.create({
      component: AddUserComponent,
      componentProps: {
        churchList,
        ageGroupList
      }
    });
    return await modal.present();
  }

  editUser = async (festivalUser: FestivalUser) => {
    const modal = await this.modalController.create({
      component: EditUserComponent,
      componentProps: {
        festivalUser
      }
    });
    return await modal.present();
  }

  deleteFestivalUser = (userId: string) => {
    this.documentService.deleteDocument(this.festivalUserService.collection, userId);
  }

  resetPassword(event, festivalUser: FestivalUser) {
    const emailAddress = festivalUser.email;
    event.stopPropagation();
    if (!emailAddress)
      alert('Missing user email address');

    this.authService.resetPasswordInit(emailAddress).then(
      () => {

        // Update LastPasswordResetDate
        festivalUser.lastPasswordResetDate = new Date(); 
        this.documentService.updateDocument(this.festivalUserService.collection, festivalUser);

        alert(`A password reset email has been sent to ${festivalUser.user.displayName}`); 
      },
      (rejectionReason) => { 
        alert(rejectionReason) 
      })
    .catch(e => { 
      alert('An error occurred while attempting to reset your password'); 
    });
  }

  getDateString = (time: { seconds: number, nanoseconds: number}): string => {
    console.log(`Time : ${JSON.stringify(time)}`);
    return formatDate(new Date(time.seconds * 1000 + time.nanoseconds/1000000), 'dd-MMM-yyyy HH:mm', 'en-AU');
  }
}